import useFetch from 'elements/Hooks/useFetch'
import React from 'react'
import { useState } from 'react'
import AddRFQ from '../../../../components/Purchasing/RFQ/AddRFQ/AddRFQ'
import { get } from 'lodash'
import { isEmpty } from 'lodash'
import { pick } from 'lodash'
import { EnquiriesApi } from '../../../../api/Sales/Enquiries'
import useTitle from '../../../../elements/Hooks/useTitle'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalShow from '../../../../elements/Hooks/useModalShow'
import Members from '../../../../api/Members'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import { RFQApi } from '../../../../api/Sales/RFQ'
import { withRouter } from 'react-router-dom'
import { message } from 'antd'
import { MODAL_TYPE_NEW } from '../../../../elements/Hooks/useModalData'
import DocumentsApi from '../../../../api/Documents'
import Templates from '../../../../api/Templates'
import Email from '../../../../api/Email'
import qs from 'query-string'

const formRef = React.createRef()
const docsApi = new DocumentsApi()
const templateApi = new Templates()
const emailApi = new Email()

function AddRFQCont(props) {
  const key = get(props.match, 'params.key')
  const values = qs.parse(props.location.search)
  const enquiryID = values.enquiryID
  const type = key ? 'edit' : 'new'

  const { fetch, fetching, data: rfq } = useFetch({
    url: `rfq/${key}`,
    dontFetch: key === undefined
  })

  useTitle(rfq.code === undefined ? `Create New RFQ` : `${rfq.code} RFQ`)
  const [isMemberOrganization, setIsMemberOrganization] = useState(true)
  const [ContactPersonLoading, setContactPersonLoading] = useState(false)
  const [contactPerson, setContactPerson] = useState([])
  const { list: enquirerList, fetching: fetchingEnquirer, fetch: fetchEnquirer } = useFetchList(
    EnquiriesApi.enquirerList
  )
  const { visible: visiblePhonebook, onShow: onShowPhoneBook, onCancel: onCancelPhoneBook } = useModalShow(
    undefined,
    fetchEnquirer
  )

  const onChangeEnquirer = async (id) => {
    console.log('onChangeEnquirer')
    if (id) {
      setContactPersonLoading(true)
      const key = id.replace('members/', '')
      const membersApi = new Members()
      const memberResponse = await membersApi.get(key)
      let memberData = await memberResponse.json()
      setIsMemberOrganization(memberData.kind !== 'individual')
      const response = await membersApi.representatives.list(key)
      let data = await response.json()
      setContactPerson(data)
      setContactPersonLoading(false)
      return id
    }
  }

  const [updating, updateFunc] = useSubmit(RFQApi.update)

  function checkForm() {
    return new Promise((res, rej) => {
      formRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          res(values)
        } else rej(err)
      })
    })
  }

  const [submitting, submitFunc] = useSubmit(RFQApi.create)

  async function submit() {
    const values = await checkForm()
    const submitted = await submitFunc(values)
    if (submitted)
      props.history.push({
        pathname: `/purchasing/rfq/${submitted._key}/update`,
      })
  }

  async function update() {
    const values = await checkForm()
    const rfqDB = await updateFunc({
      ...pick(rfq, ['_key', '_id', '_rev']),
      ...values,
    })
    if (rfqDB) fetch()
  }

  const [removing, removeFunc] = useSubmit(RFQApi.remove)

  async function remove() {
    const removed = await removeFunc({
      ...pick(rfq, ['_key', '_rev', '_id']),
    })
    if (removed)
      props.history.replace({
        pathname: `/purchasing/rfq/`,
      })
  }

  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions('rfq', rfq.status),
    [rfq.status, isEmpty(rfq.status)]
  )
  const isNew = type === MODAL_TYPE_NEW
  const isUpdatable = actions.find((a) => a.key === 'update') || isNew
  const isRemovable = actions.find((a) => a.key === 'remove') || false
  const [submittingOperation, submitOperation] = useSubmit(RFQApi.operation)

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    const RFQDB = await submitOperation({
      status: operation,
      ...pick(rfq, ['_key', '_rev', '_id']),
    })
    if (RFQDB) {
      fetch()
    }
    hide()
  }

  const [submittingTemplate, submitTemplate] = useSubmit(templateApi.read, true)
  const [submittingRFQTemplate, submitRFQTemplate] = useSubmit(emailApi.rfqTemplate, true)
  const [submittingRFQFiles, submitRFQFiles] = useSubmit(RFQApi.files, true)

  const [emailTemplate, setEmailTemplate] = useState('')
  const [emailDetails, setEmailDetails] = useState('')
  const [emailFiles, setEmailFiles] = useState([])
  const [emailLines, setEmailLines] = useState([])

  const { visible: visibleEmail, onShow: onShowEmail, onCancel: onCancelEmail } = useModalShow(async () => {
    let hide = message.loading('Fetching Email Template ...', 0)

    const company = get(rfq, 'company._id', '').replace('members/', '')
    const rfqTemplate = await submitTemplate(company, 'rfq')
    const emailDetails = get(rfqTemplate, 'email') || {}
    const data = await submitRFQTemplate({
      receiver: get(rfq, 'vendorRep.fn'),
      companyRep: get(rfq, 'companyRep.fn'),
      company: get(rfq, 'company.fn'),
      address: get(rfq, 'company.address.label'),
      phone: get(rfq, 'company.phone.label'),
      url: get(rfq, 'url'),
      ...emailDetails,
    })
    const isExistingVendor = get(rfq, 'isExistingVendor', false)
    let htmlLink = ''
    if (!isExistingVendor) {
      const start = data.html.slice(0, 156)
      const text =
        'Please note that in order for us to issue you with a Purchase Order, we require you to be a registered vendor.' +
        '\nPlease click on the following address to register with us:'
      const site = company === '10333996845050' ? 'http://vendor.souter-trading.com' : 'http://vendor.mondiale.com'

      htmlLink = `<p>${text} <a href="${site}"> ${site} </a></p>`
    }
    data.html = data.html.replace('{REG}', htmlLink)
    //console.log(data.html)

    const filesList = await submitRFQFiles([rfq._id])
    setEmailFiles(filesList)
    const filesMapped = filesList.map((f) => f.uuid)
    setEmailTemplate(data.html)
    setEmailDetails({
      to: get(rfq, 'vendorRep.email.label'),
      cc: get(rfq, 'companyRep.email.label'),
      bcc: get(emailDetails, 'bcc'),
      from: get(emailDetails, 'from'),
      subject: `[${get(rfq, 'enquiry.code')}] ${get(emailDetails, 'subject')}`,
      attachments: filesMapped,
    })
    setEmailLines([rfq])
    hide()
  })
  const isConfirmed = ['Confirmed'].includes(rfq.status)
  const isIssued = ['Issued'].includes(rfq.status) || get(rfq, 'issuance.issued') === true
  const isQuoted = ['Quoted'].includes(rfq.status)
  //const isIssued = get(rfq, 'issuance.issued') === true

  React.useEffect(() => {
    if (get(rfq, 'vendor._id')) onChangeEnquirer(rfq.vendor._id)
  }, [rfq._key])
  const [modalID, setModalID] = React.useState(1)
  React.useEffect(() => {
    setModalID((old) => old + 1)
  }, [enquirerList.length])
  return (
    <AddRFQ
      {...{
        type,
        enquiryID,
        fetching,
        submitting,
        updating,
        fetch,
        rfq,
        submit,
        removing,
        remove,
        update,
        formRef,
        visiblePhonebook,
        onShowPhoneBook,
        onCancelPhoneBook,
        onChangeEnquirer,
        contactPerson,
        setContactPerson,
        enquirerList,
        fetchingEnquirer,
        fetchEnquirer,
        ContactPersonLoading,
        setContactPersonLoading,
        isMemberOrganization,
        //rfq cont
        isNew,
        isUpdatable,
        isRemovable,
        actions,
        fetchingActions,
        isQuoted,
        fetchActions,
        handleActions,
        onShowEmail,
        visibleEmail,
        onCancelEmail,
        emailTemplate,
        emailDetails,
        emailFiles,
        emailLines,
        isConfirmed,
        isIssued,
        modalID,
      }}
    />
  )
}

export default withRouter(AddRFQCont)
